import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import useHubspotVariables from 'modules/onboarding/hooks/useHubspotVariables'

import BookingCard from 'modules/billing/pages/PaymentSuccessPage/components/BookingCard'

const PaymentSuccessHeader = () => {
  const { isOnboardingSegment } = useHubspotVariables()

  return (
    <Box gap="s24">
      <Box gap="s16" textAlign="center" style={{ maxWidth: '540px' }}>
        <Text size="600" weight="medium" color="grey1000">
          {i18n.t('pricing_plans.success.header.title')}
        </Text>
        <Text weight="normal" size="300" color="grey800">
          {i18n.t('pricing_plans.success.header.sentence')}
        </Text>
      </Box>
      {isOnboardingSegment && <BookingCard />}
    </Box>
  )
}

export default PaymentSuccessHeader
